import { render, staticRenderFns } from "./moveForm.vue?vue&type=template&id=db551bec"
import script from "./moveForm.vue?vue&type=script&lang=js"
export * from "./moveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports